import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { useState } from "react";
import { attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { constraintsOptions, formatColumnValue } from "components/PimDashboard/data";
import { datatypes } from "data/globalData";

const DisplayInfoWithEditTab = ({ columnData, data, modalOpen, setModalOpen, submitFunction, width = "24%", longWidth = "49%" }) => {
	const [updatedData, setUpdatedData] = useState(data);

	const handleCloseModal = () => {
		setUpdatedData(data);
		setModalOpen(false);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		if (typeof submitFunction === "function") submitFunction(updatedData, columnData);
	};
	return (
		<Box width="99%" display="flex" flexWrap="wrap" columnGap="1%" boxSizing="border-box">
			{columnData
				?.filter((row) => row?.constraints?.[constraintsOptions.DISPLAY.key] === true)
				.map((row) => {
					// const isDate = labelData[colName]?.isDate;
					return (
						<Stack
							width={row.data_type === datatypes.LONGTEXT.key ? longWidth : width}
							spacing={0}
							key={row?.name}
							overflow="hidden"
							direction="row"
							border={`1px solid white`}
							boxSizing="border-box">
							<Typography
								variant="subtitle2"
								color={grey[200]}
								sx={{
									width: "38%",
									p: "10px 2%",
									background: "#000",
									overflow: "hidden",
									borderRadius: "1px 0px 0px 1px",
								}}>
								{row?.name}
							</Typography>
							<Typography
								variant="subtitle2"
								sx={{
									width: "55%",
									p: "10px 2%",
									background: grey[200],
									fontWeight: 400,
									overflow: "hidden",
									borderRadius: " 0px 1px 1px 0px",
								}}>
								{data?.[row?.key] !== undefined ? formatColumnValue(data?.[row?.key], row) : ""}
							</Typography>
						</Stack>
					);
				})}

			<Dialog fullWidth maxWidth="lg" open={modalOpen} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
				<Box width="98%" p={2} boxSizing="border-box">
					<Stack width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={1}>
						<Stack direction="row" width="100%" flexWrap="wrap" columnGap="3%" rowGap={1}>
							<Typography textAlign="center" variant="h6" width="100%">
								Edit Details
							</Typography>
							{columnData?.map((column) => {
								return (
									<RenderInputField
										column={column}
										error={{}}
										selectOptObjName={attrValAssocObj}
										data={updatedData}
										setData={setUpdatedData}
									/>
								);
							})}
						</Stack>
					</Stack>
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={handleCloseModal}>
						Cancel
					</Button>
					<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default DisplayInfoWithEditTab;
